module.exports = __webpack_public_path__ + "static/img/forests07.1dadacc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/forests07.jpg
// module id = czCP
// module chunks = 0